import { isToday, isWeekend, format } from 'date-fns';

const Day = ({ day, selectedDate, onClick, children }) => {
    
    return (
        <div className={`calendar__week-day ${selectedDate == format(day.date, "yyyy-MM-dd") ? "calendar__week-day--active" : ""}`} onClick={onClick}>
            <div className={`calendar__week-day-label ${isWeekend(day.date) ? "calendar__week-day-label--weekend" : ""}`}>
                {isToday(day.date) && (
                    <div className="calendar__week-day-label-current">Today</div>
                )}
                <span>{format(day.date, "EE").slice(0, 2)}</span>
                <span>{format(day.date, "dd")}th</span>
            </div>
            <div className="calendar__week-day-events">
                {children}
            </div>
        </div>
    );
};

export default Day;
